import { createResource, type RouteResource } from '@atlassian/react-resource-router';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const rapidboardResource: RouteResource<any> = createResource<any>({
	type: 'RESOURCE_TYPE_RAPIDBOARDS_RESOURCE',
	getKey: ({ match }) => match.query.rapidView || '',
	getDataLoader: () =>
		import(
			/* webpackChunkName: "async-resource-rapidboards-rapidboard-resource-data", jiraSpaEntry: "async-resource-rapidboards-rapidboard-resource-data" */ './RapidBoardResourceType.tsx'
		),
	maxAge: Number.MAX_VALUE,
	isBrowserOnly: true,
});
